module.exports = __webpack_public_path__ + "img/paragraph-1.11feb0a6.svg";